import { render, staticRenderFns } from "./childTable.vue?vue&type=template&id=69f6085a&scoped=true&"
import script from "./childTable.vue?vue&type=script&lang=js&"
export * from "./childTable.vue?vue&type=script&lang=js&"
import style0 from "./childTable.vue?vue&type=style&index=0&id=69f6085a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f6085a",
  null
  
)

export default component.exports